export const model = {
  meta: { experts: 5, modelsCount: 3 },
  data: [
    {
      id: 'f88d74af-7073-4fb8-b33f-c45fe106791d',
      name: 'Модель самооцінки',
      a: 55,
      b: 120,
      T: 100,
      p: 6,
      questions: [
        {
          question: 'Досвід роботи',
          answers: [
            { answer: 'До 3 років', score: 10 },
            { answer: 'З 3 до 5 років', score: 15 },
            { answer: 'З 5 до 10 років', score: 20 },
            { answer: 'Більше 10 років', score: 30 },
          ],
        },
        {
          question: 'Посада',
          answers: [
            { answer: 'Виконавець', score: 20 },
            { answer: 'Керівник середньої ланки', score: 22 },
            { answer: 'Керівник вищої ланки', score: 25 },
            { answer: 'Топ менеджер', score: 30 },
          ],
        },
        {
          question: 'Теоретичний рівень підготовки',
          answers: [
            { answer: 'Бакалавр', score: 15 },
            { answer: 'Магістр', score: 20 },
            { answer: 'Кандидат наук', score: 25 },
            { answer: 'Доктор наук', score: 30 },
          ],
        },
        {
          question: 'Імідж в ділових колах',
          expertAnswer: 10,
          answers: [
            { answer: 'Маловідома в ділових колах людина', score: 10 },
            { answer: 'Людина, визнана фахівцем в окремій галузі', score: 20 },
            { answer: 'Людина, визнана фахівцем у кількох галузях', score: 25 },
            { answer: 'Широковизнанна в ділових колах людина', score: 30 },
          ],
        },
      ],
    },
    {
      id: '77f9edd8-e6b2-4af6-9e2c-22cf34e2a2fa',
      name: 'Модель спеціальних вмінь і навичок',
      a: 60,
      b: 220,
      T: 190,
      p: 10,
      questions: [
        {
          question: 'Рівень знань API-driven Single Page Apps',
          expertAnswer: 40,
          answers: [
            { answer: 'Низький', score: 10 },
            { answer: 'Середній', score: 15 },
            { answer: 'Вище середнього', score: 30 },
            { answer: 'Високий', score: 40 },
          ],
        },
        {
          question: 'Рівень знань MySQL',
          expertAnswer: 40,
          answers: [
            { answer: 'Низький', score: 15 },
            { answer: 'Середній', score: 20 },
            { answer: 'Вище середнього', score: 35 },
            { answer: 'Високий', score: 40 },
          ],
        },
        {
          question: 'Рівень знань JavaScript',
          answers: [
            { answer: 'Низький', score: 15 },
            { answer: 'Середній', score: 20 },
            { answer: 'Вище середнього', score: 25 },
            { answer: 'Високий', score: 40 },
          ],
        },
        {
          question: 'Рівень знань C# і/або .NET',
          answers: [
            { answer: 'Низький', score: 10 },
            { answer: 'Середній', score: 20 },
            { answer: 'Вище середнього', score: 35 },
            { answer: 'Високий', score: 50 },
          ],
        },
        {
          question: 'Рівень знань Python',
          answers: [
            { answer: 'Низький', score: 10 },
            { answer: 'Середній', score: 20 },
            { answer: 'Вище середнього', score: 40 },
            { answer: 'Високий', score: 50 },
          ],
        },
      ],
    },
    {
      id: 'bd345cc7-9832-472a-9cbe-81672ee853a5',
      name: 'Модель психофізіологічних якостей особистості',
      a: 20,
      b: 180,
      T: 140,
      p: 9,
      questions: [
        {
          question:
            'Коли між людьми відбувається конфлікт на ґрунті ідей, я віддаю перевагу тій стороні, що',
          answers: [
            {
              answer:
                'приймає, визнає конфлікт і намагається висловити його відкрито',
              score: 0,
            },
            {
              answer: 'більше за інших зачіпає мої власні цінності та ідеали',
              score: 15,
            },
            {
              answer: 'краще за інших відображає мої особисті погляди і досвід',
              score: 20,
            },
            {
              answer: 'викладає аргументи найбільш коротко і переконливо',
              score: 40,
            },
          ],
        },
        {
          question:
            'Коли я починаю працювати над проектом у складі групи, найважливіше для мене',
          answers: [
            { answer: 'зрозуміти мету і значення цього проекту', score: 5 },
            {
              answer: 'розкрити мету і цінності учасників робочої групи',
              score: 22,
            },
            {
              answer: 'визначити, як ми збираємося розробляти даний проект',
              score: 25,
            },
            {
              answer:
                'щоб робота над проектом була організована і зрушила з місця',
              score: 30,
            },
          ],
        },
        {
          question:
            'Говорячи в цілому, я засвоюю нові ідеї найкраще, коли можу',
          answers: [
            { answer: 'застосувати їх до конкретних ситуацій', score: 5 },
            {
              answer: 'зосередитися на них і ретельно їх проаналізувати',
              score: 10,
            },
            {
              answer: 'зрозуміти, наскільки вони подібні до звичних ідей',
              score: 25,
            },
            { answer: 'протиставити їх іншим ідеям', score: 30 },
          ],
        },
        {
          question:
            'Коли я читаю звіт про роботу, я звертаю найбільше уваги на',
          answers: [
            {
              answer: 'близькість висновків до мого особистого досвіду',
              score: 5,
            },
            { answer: 'можливість виконання даних рекомендацій', score: 10 },
            {
              answer:
                'надійність і обґрунтованість результатів фактичними даними',
              score: 30,
            },
            { answer: 'розуміння автором цілей та завдань роботи', score: 40 },
          ],
        },
        {
          question:
            'Коли переді мною поставлено завдання, перше, про що я хочу довідатися - це',
          answers: [
            {
              answer: 'який найкращий метод для вирішення даного завдання',
              score: 5,
            },
            {
              answer: 'кому і коли потрібно, щоб це завдання було вирішене',
              score: 15,
            },
            { answer: 'чому це завдання варто вирішувати', score: 30 },
            {
              answer:
                'яка пряма, негайна користь від вирішення даного завдання',
              score: 40,
            },
          ],
        },
      ],
    },
  ],
};
